import React from 'react';
import { MDBBtnFixedItem, MDBCard, MDBCardTitle, MDBCardText, MDBFormInline, MDBBadge, MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBCol, MDBBtn, MDBIcon } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import UnitListCard from './ComponentFragments/UnitListCard';
import Formatter from '../Utilities/Formatter';

export default class Recruiting extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            promoteoutData: []
        }
        this.formatter = new Formatter();
    }

    

    async componentWillMount() {
        this.props.loaderOn();
        var dl = new DataLayer();
        var wtf = "";
        await dl.Get('/common/getpromoteouts', 200).then((response) => {
            var mytest = '';
            this.setState({
                promoteoutData: response.data
            });
            this.props.loaderOff();
        })
    }


    render() {
        let headerText = "My Promoteouts";
        return (
            <div>
                <Header headerText={headerText}
                    hideSearch={true}
                />
                <MDBRow>
                    {
                        this.state.promoteoutData.map((unit) => {
                        return (
                            <MDBCol xl="4" lg="6" md="6" sm="12" className="mb-r" >
                                <UnitListCard {...this.props}
                                    unitName={unit.unitName}
                                    managerName={unit.managerName}
                                    telephoneCell={unit.telephoneCell}
                                    sales={unit.sales}
                                    prevSegmentSales={unit.prevSegmentSales}
                                    sfId={unit.sfId}
                                    unitId={unit.unitId}
                                    unitName={unit.unitName}
                                    isPromoteoutList={true}
                                    active={unit.active}
                                    startWeekId={unit.startWeekId}
                                    endWeekId={unit.endWeekId}
                                    status={unit.status}
                                />
                                {/*
                                    <UnitListCard
                                        unitName={unit.unitName}
                                        managerName={unit.managerName}
                                        telephoneCell={unit.telephoneCell}
                                        sales={unit.sales}
                                        prevSegmentSales={unit.prevSegmentSales}
                                        sfId={unit.sfId}
                                        unitId={unit.unitId}
                                        unitName={unit.unitName}
                                        loaderOff={this.props.loaderOff}
                                        loaderOn={this.props.loaderOn}
                                    />
                                    */}
                            </MDBCol>


                        );
                    })
                }
                </MDBRow>


            </div>
        );
    }
}